var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommpactLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 850 250",
    style: {
      enableBackground: "new 0 0 850 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#007EC2;}\n\t.st1{fill:#F7941D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.65,172.96c-24.57,0-42.72-19.25-42.72-42.88c0-23.63,18.15-43.34,42.88-43.34 c15.65,0,25.35,5.79,33.02,14.24l-11.74,12.67c-5.79-6.1-11.89-10.33-21.44-10.33c-13.77,0-23.78,11.89-23.78,26.44 c0,14.87,10.17,26.76,24.72,26.76c8.92,0,15.49-4.22,21.44-10.33l11.42,11.27C101.31,166.54,91.77,172.96,75.65,172.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M323.68,86.74c18,0,28.95,11.42,28.95,31.61v52.73h-18.93v-46.94c0-13.14-6.1-20.19-16.74-20.19 c-10.33,0-17.68,7.2-17.68,20.5v46.63h-18.93v-47.1c0-12.83-6.26-20.03-16.74-20.03c-10.48,0-17.68,7.82-17.68,20.66v46.47h-18.93 V88.46h18.93v12.52c5.32-7.35,12.52-14.24,25.19-14.24c11.89,0,20.19,5.79,24.57,14.55C302.39,92.53,311.16,86.74,323.68,86.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M464.51,86.74c18,0,28.95,11.42,28.95,31.61v52.73h-18.93v-46.94c0-13.14-6.1-20.19-16.74-20.19 c-10.33,0-17.68,7.2-17.68,20.5v46.63h-18.93v-47.1c0-12.83-6.26-20.03-16.74-20.03c-10.48,0-17.68,7.82-17.68,20.66v46.47h-18.93 V88.46h18.93v12.52c5.32-7.35,12.52-14.24,25.19-14.24c11.89,0,20.19,5.79,24.57,14.55C443.23,92.53,451.99,86.74,464.51,86.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M553.71,172.96c-15.96,0-26.29-9.08-32.86-19.09v42.25h-7.67V91.27h7.67v17.84 c6.89-10.48,17.06-19.72,32.86-19.72c19.25,0,38.81,15.49,38.81,41.47v0.31C592.51,157.15,572.95,172.96,553.71,172.96z  M584.22,131.18c0-20.97-14.55-34.42-31.3-34.42c-16.59,0-32.55,13.93-32.55,34.27v0.31c0,20.5,15.96,34.27,32.55,34.27 c17.37,0,31.3-12.67,31.3-34.11V131.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M664.65,171.08v-13.3c-5.48,7.67-15.33,15.18-30.51,15.18c-14.87,0-30.83-8.45-30.83-25.04v-0.31 c0-16.59,14.24-25.98,34.89-25.98c11.11,0,18.78,1.41,26.45,3.44v-3.44c0-16.12-9.86-24.41-26.29-24.41 c-9.7,0-17.68,2.66-25.04,6.42l-2.82-6.73c8.76-4.07,17.37-6.88,28.32-6.88c20.5,0,33.33,10.64,33.33,31.29v49.76H664.65z  M664.81,132.12c-6.73-1.72-15.65-3.6-27.07-3.6c-16.9,0-26.29,7.51-26.29,18.62v0.31c0,11.58,10.95,18.31,23.16,18.31 c16.27,0,30.2-10.01,30.2-24.57V132.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M725.37,172.96c-23,0-40.68-19.09-40.68-41.47v-0.31c0-22.38,17.84-41.78,40.68-41.78 c15.02,0,24.41,6.88,31.92,14.71l-5.48,5.63c-6.88-7.04-14.71-13.14-26.6-13.14c-18.15,0-32.23,15.18-32.23,34.27v0.31 c0,19.25,14.55,34.58,32.86,34.58c11.27,0,20.03-5.79,26.76-13.3l5.32,4.69C749.78,166.38,740.08,172.96,725.37,172.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M804.55,172.49c-12.36,0-22.38-6.73-22.38-21.91V98.32h-11.58v-7.04h11.58V65.77h7.67v25.51h28.01v7.04 h-28.01v51.48c0,11.42,6.73,15.49,15.96,15.49c3.91,0,7.2-0.78,11.74-2.82v7.2C813.47,171.55,809.55,172.49,804.55,172.49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M215.39,71.88v13.49h-2.29c-3.3-3.79-7.05-7.15-11.2-10.03v-3.45H215.39z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M166.99,72.89c-28.17,0-51,22.83-51,50.99c0,7.47,1.61,14.56,4.49,20.96c0.19,0.43,0.19,0.43,0.19,0.43 c0.22,0.46,1.05,1.92,1.86,3.26l1.84,3.04c0.81,1.33,2.12,3.52,2.93,4.85l38.23,63.43c0.8,1.34,2.12,1.34,2.93,0l38.23-63.43 c0.8-1.34,2.12-3.52,2.93-4.86l1.8-2.99c0.81-1.34,1.65-2.82,1.88-3.3c0,0,0,0,0.2-0.44c2.89-6.4,4.49-13.49,4.49-20.96 C217.99,95.72,195.16,72.89,166.99,72.89z M166.99,150.38c-14.63,0-26.5-11.86-26.5-26.5s11.86-26.5,26.5-26.5 c14.63,0,26.5,11.86,26.5,26.5S181.62,150.38,166.99,150.38z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 199.03,
    y: 27.72,
    className: "st1",
    width: 13.48,
    height: 13.48
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.35,
    y: 49.9,
    className: "st1",
    width: 13.48,
    height: 13.48
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommpactLogo);
export default __webpack_public_path__ + "static/media/commpact_logo.35bd24c47380c7371265ccca381661f8.svg";
export { ForwardRef as ReactComponent };